import '../styles/css/fonts.css'


export const colors = {
    green: "#828C7A",
    darkGreen:"#4b5246", 
    accentBlue: "#6D9886",
    black: "#2C2C2C",
    softBlack: "#707070",
    softWhite: "#F4F2EF",
    softYellow: "#f5e5ce",
    white: "#FBFBFB",
    red: "#FF0000",
    yell: "#FFFF00",
    none: "none"

}

export const size = {
    Xheader: "calc(38px)",
    Xtittle: "calc(35px)",
    XList: "calc(22px)",
    Xtext: "calc(20px)",
    Xmini: "calc(16px)",

    Wheader: "calc(35px)",
    Wtittle: "calc(30px)",
    WList: "calc(18px)",
    Wtext: "calc(16px)",
    Wmini: "calc(14px)",

    Mheader: "calc(30px)",
    Mtittle: "calc(21px)",
    Mtext: "calc(14px)",
    Mmini: "calc(12px)",
}

export const font = {

    light: "RaleLight",
    medium: "RaleMedium",

    Lblack: "LatoBlack",
    Lbold: "LatoBold",
    Lregular: "LatoRegular",
    Llight: "LatoLight",
    Lthin: "LatoThin",

    Rblack: "RaleBlack",
    Rxbold: "RaleExtraBold",
    Rbold: "RaleBold",
    Rsemi: "RaleSemi",
    Rregular: "RaleRegular",
    Rmedium: "RaleMedium",
    Rlight: "RaleLight",
    Rxlight: "RaleExtraLight",
    Rthin: "RaleThin",

}